import { Box, SxProps, Theme, Typography } from "@mui/material";
import { combineSx, createStyleSheet } from "../utils/styles";

import ClinicianBadge from "./ClinicianBadge";
import { ClinicianData } from "../features/data/patientApiSlice";

const ClinicianBadgeList = (props: {
  clinicians: ClinicianData[];
  sx?: SxProps<Theme>;
}) => {
  const { clinicians, sx } = props;
  // We'll assume the order of the clinicians is oldest->newest, and we'll show
  // the newest clinician on top. Since we're showing the badges overlapped, we'll
  // show the last 'maxBadges' clinicians in the array.
  return clinicians.length > 0 ? (
    <Box sx={combineSx(styles.container, sx)}>
      {clinicians.map((clinician) => (
        <Box key={clinician.name} sx={styles.clinicianRow}>
          <ClinicianBadge clinician={clinician} />
          <Typography variant="detailCellBody" sx={styles.clinicianText}>
            {clinician.name}
          </Typography>
        </Box>
      ))}
    </Box>
  ) : null;
};

const styles = createStyleSheet({
  container: {
    p: 1,
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
  },
  clinicianRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  clinicianText: {
    marginLeft: 1,
  },
});

export default ClinicianBadgeList;
